import React from "react";

const Cloud = ({ text, onClick }) => {
  return (
    <div
      className="tw-relative tw-inline-block tw-cursor-pointer cloud-bounce"
      onClick={onClick}
    >
      <img
        src={process.env.PUBLIC_URL + "/assets/images/cloud.svg"}
        alt="Cloud"
        className="tw-w-40 md:tw-w-[220px] tw-h-auto"
      />
      {text && (
        <p className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-semibold tw-text-center tw-text-sm md:tw-text-base tw-pt-4 md:tw-pt-6">
          {text}
        </p>
      )}
    </div>
  );
};

export default Cloud;
